// Registers any changes made to the comment form on feed card entries
export const REGISTER_FEED_ENTRY_UI_CHANGE = 'REGISTER_FEED_ENTRY_UI_CHANGE';

export default {
  REGISTER_FEED_ENTRY_UI_CHANGE
};
